import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FileField, FileInput } from 'react-admin'
import get from 'lodash/get'
import SparkMD5 from 'spark-md5'

import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

import httpClient from '../../utils/httpClient'

const MAX_SIZE = 1024 * 1024 * 1024 * 2

const API_BASE = process.env.API_URL
const UPLOAD_INIT = `${API_BASE}/api/v1/files/upload-url/`
const UPLOAD_COMPLETE = `${API_BASE}/api/v1/files/complete/`

const GCS_CHUNK = 8 * 1024 * 1024 // 8MB

async function uploadToGCS(file, uploadUrl, onProgress) {
  let offset = 0

  while (offset < file.size) {
    const chunk = file.slice(offset, offset + GCS_CHUNK)

    const res = await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Range": `bytes ${offset}-${offset + chunk.size - 1}/${file.size}`
      },
      body: chunk
    })

    if (res.status !== 308 && res.status !== 200 && res.status !== 201) {
      const txt = await res.text()
      throw new Error(`GCS upload failed ${res.status}: ${txt}`)
    }

    offset += chunk.size
    onProgress(offset / file.size * 100)
  }
}

async function createUploadSession(filename, contentType) {
  const res = await httpClient(UPLOAD_INIT, {
    method: "POST",
    body: JSON.stringify({
      filename,
      content_type: contentType
    }),
    headers: new Headers({
      "Content-Type": "application/json",
      Accept: "application/json"
    })
  })
  return res.json   // { uploadUrl, blobName }
}


class DocumentoUploadDialog extends Component {
  state = {
    open: false,
    uploading: false,
    completed: 0,
    buffer: 0,
    error: null
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleUpload = async () => {
    this.setState({
      uploading: true,
      completed: 0,
      buffer: 0
    });

    try {
      const document = await this.documentUpload(
        this.props.file.rawFile,
        this.props.file.title
      )
      this.setState({ uploading: false })
      this.props.changeSelectValue(document.id, document.file_name)
      this.handleClose()
    } catch (e) {
      console.log(e)
      this.setState({
        uploading: false,
        completed: 0,
        buffer: 0,
        error: e
      })
    }

  }

  documentUpload = async (file, filename) => {
    this.setState({ completed: 0, buffer: 0 })

    // 1) Crear sesión resumable en GCS
    const { uploadUrl, blobName } = await createUploadSession(filename, file.type)

    // 2) Subir directo a Google Cloud Storage
    await uploadToGCS(file, uploadUrl, progress => {
      this.setState({ completed: progress, buffer: progress })
    })

    // 3) Calcular MD5 (opcional pero tu backend lo valida)
    const buffer = await file.arrayBuffer()
    const checksum = SparkMD5.ArrayBuffer.hash(buffer)

    // 4) Cerrar upload y crear Documento en backend
    const res = await httpClient(UPLOAD_COMPLETE, {
      method: "POST",
      body: JSON.stringify({
        blobName,
        filename,
        type: this.props.documentType,
        decreto: this.props.decreto,
        size: file.size,
        checksum
      }),
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json"
      })
    })

    return res.json
  }


  render() {
    const { open, uploading, completed, buffer } = this.state

    return (
      <div>
        <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
          Subir Documento
          <CloudUploadIcon style={{ marginLeft: '10px' }}/>
        </Button>
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth={'sm'}
        >
          <DialogTitle id="form-dialog-title">Subir Documento</DialogTitle>
          <DialogContent>
            <FileInput
              source="document_upload"
              label="Documento"
              placeholder={<p>Arrastra un archivo, o haz clic aquí para buscarlo, las extensiones permitidas son: <strong>{this.props.acceptedExt.join(', ')}</strong></p>}
              accept={this.props.acceptedExt.join(', ') || "*/*"}
              maxSize={MAX_SIZE}
            >
              <FileField source="src" title="title" />
            </FileInput>
            {!!this.state.error && <p>Error al subir el archivo, si el problema persiste vuelva a iniciar sesion.</p>}
            {uploading && <LinearProgress variant="buffer" value={completed} valueBuffer={buffer} />}
            {uploading && `${completed.toFixed(2)}%`}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={this.handleUpload} color="primary" disabled={uploading}>
              {uploading ? "Subiendo Archivo..." : "Subir Documento"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const file = get(state, 'form.record-form.values.datasheet.document_upload', null)
  const decreto = get(state, 'form.record-form.values.decreto_id', null)
  return { file, decreto }
}

export default connect(mapStateToProps)(DocumentoUploadDialog)
